/* Gates endpoints only the mock API has (no backend yet); on a real server they're skipped. */

export const SANDBOX_DATA = process.env.REACT_APP_MOCK_API === '1';

/** GET a sandbox-only endpoint; resolves undefined on a real server. */
export function sandboxGet(api: { get: (url: string) => Promise<any> }, url: string): Promise<any> {
    if (!SANDBOX_DATA) return Promise.resolve(undefined);
    return api
        .get(url)
        .then((r: any) => r.data)
        .catch(() => undefined);
}
